import { useSelector } from 'react-redux';

import { getFeatureOverride } from './featuresModule';

export default function useFeatureOverride(handle) {
  const feature = useSelector((state) => getFeatureOverride(state, handle));

  return feature;
}
